(function ($, Drupal) {

  Drupal.behaviors.desktopMenu = {

    attach: function (context, settings) {

      once('desktopMenuLoad', '.top-menu', context).forEach(function (element, index) {

        // If the second level menu is off the right, then set it to be right: 0 rather than left: 0

        const secondLevelMenus = element.querySelectorAll(':scope > .menu > .menu-item--expanded > .menu');
        const mediaQuery = window.matchMedia('(min-width: 1080px)');

        function setSecondLevelMenuPosition(second) {
          // Re-set the positions in case they were previously set
          second.style.left = 0;
          second.style.right = '';
          const menuRight = window.innerWidth - second.getBoundingClientRect().right;
          if (menuRight < 0) {
            second.style.left = 'unset';
            second.style.right = 0;
          }
        }

        if (mediaQuery.matches) {
          secondLevelMenus.forEach(second => {
            setSecondLevelMenuPosition(second);
          });
        }

        // Update on window resize
        $(window).resize(_.throttle(function () {
          if (mediaQuery.matches) {
            secondLevelMenus.forEach(second => {
              setSecondLevelMenuPosition(second);
            });
          }
        }, 300));

      });

    }

  };

})(jQuery, Drupal);
